import { ModelApiKey } from '../types/models'
import { LocaleCode } from '../../i18n'

export const paths = {
  [LocaleCode.EN]: {
    [ModelApiKey.Index]: { path: '' },
    [ModelApiKey.Page]: { path: '' },
    [ModelApiKey.Project]: { path: 'projects' },
    [ModelApiKey.Location]: { path: 'locations' },
    [ModelApiKey.Article]: { path: 'insights' }
  }
  // [LocaleCode.SL]: {
  //   [ModelApiKey.Index]: { path: '' },
  //   [ModelApiKey.Page]: { path: '' },
  //   [ModelApiKey.Project]: { path: 'projekti' },
  //   [ModelApiKey.Location]: { path: 'lokacije' }
  // }
}
